import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import MarkdownRenderer from "../../MarkdownRenderer";
import styles from "../agent-response.module.scss";

type PressReleaseQAAgentProps = {
  parsedContent: any;
};

export default function PressReleaseQAAgent({
  parsedContent,
}: PressReleaseQAAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);

  // Extract the answer text
  const answerText = finalAnswer?.finalAnswer || parsedContent?.finalAnswer || "";

  return (
    <div style={{ padding: "16px 0" }}>
      <MarkdownRenderer content={answerText} />
      <div className={styles.finalQuestion}>{finalAnswer?.question}</div>
    </div>
  );
}
